var touched = false;

export default function isTouch() {
  return touched;
}

function wasTouched() {
  touched = true;
  document.removeEventListener('touchstart', wasTouched, {passive: true});
  document.querySelector('body').classList.add('supports-touch');
  document.dispatchEvent(
    new CustomEvent('theme:touch', {
      bubbles: true,
    })
  );
}

document.addEventListener('touchstart', wasTouched, {passive: true});
